import React from "react";
import "./Footer.scss";
const Footer = () => {
  return (
    <div className="footer">
      <div className="footer__text">
        &copy; 2022 - Pedro Salazar
      </div>
    </div>
  );
};

export default Footer;
